<template>
  <div class="tkCmp full-height linear-main3">
    <ld-header
      @click-left="$router.push({path:'/tk/tkQuery'})"
      :transparent="true"
      :white="true"
      :title="$t('A127','预订完成')"
    />
    <div class="pad-8">
      <travel-tips :city-id="tkSearchInfo.arrport.cityId" />
      <!--  -->
      <div
        class="pad-b-5"
        v-for="(info,tkcmpindex) in flights"
        :key="tkcmpindex"
      >
        <div class="pad-b-20 white">
          <div class="font24 font-lg pad-b-5">
            <ld-icon
              :type="info.realOrderStatus!=1&&info.isShowApproval ? 'iconshenpi1' :
              detail.isShowPay == 1 ? 'iconzhifu' :
              'icondingzuoshj-icon-Reser'"
              size="30"
              class="order-status__icon"
            />
            {{ info.orderStatusRemark }}
          </div>
          <p v-show="info.realOrderStatus==1">
            {{ $t('C417','特别提示') }}！
          </p>
          <p v-show="info.realOrderStatus==1">
            您本次预订占座未成功，需要向航空公司申请座位，请等待服务商回复。如有疑问，请致电服务商咨询!
          </p>
          <p
            class="pad-b-5"
            v-show="info.realOrderStatus!=1&&!info.isShowApproval"
          >
            订单已成功提交！
          </p>
          <p
            class="pad-b-5"
            v-show="info.realOrderStatus!=1&&info.isShowApproval"
          >
            预订成功，请及时送审!
          </p>
          <p
            class="pad-b-5"
            v-show="info.realOrderStatus!=1&&!info.isShowApproval"
          >
            出票情况以收到短信为准!
          </p>
        </div>

        <div class="pad-b-5">
          <van-cell>
            {{ $t('F001','订单号') }}：{{ info.orderNo }}
            <van-tag type="warning" v-if="'' != info.productColor && 3 == info.productType"
                     :color="info.productColor">
              {{ info.productTag }}
            </van-tag>
            <van-tag type="warning" v-else>
              {{ info.productTag | productTag }}
            </van-tag>
            <span
              class="fr main-color"
              @click="toDetail(info.id)"
            >{{ $t('B011','查看订单') }}</span>
          </van-cell>
        </div>
        <div class="pad-b-5">
          <voyage
            :flights="info.orderRangeBeanList"
            :show-rule="true"
          />
        </div>
        <van-cell>
          <!--          {{ $t('C001','乘机人') }}：{{ info.orderPsgBeanList|getName }}-->
          <traver
            :traveler-list="info.orderPsgBeanList"
            :disabled="true"
            :add-button="false"
            :title="$t('C001','乘机人')"
          />
        </van-cell>

      </div>
      <!--  -->
      <ld-button
        detault
        @click="$router.push({path:'/tk/tkQuery'})"
      >
        {{ $t('B012','继续预订') }}
      </ld-button>
      <div
        class="qrCodbox"
        v-show="airlineData.qrCodeUrl"
      >
        <img :src="airlineData.qrCodeUrl">
        <p>{{ airlineData.title }}</p>
      </div>
    </div>

    <!--  -->
    <ld-tabbar
      ref="tabbar"
      :price-list="priceList"
    >
      <van-row
        class="bg-white full-width pad-lr-10 shadow"
        type="flex"
        align="center"
        justify="space-between"
      >
        <van-col span="10">
          <span class="font12 money-color">&yen; </span>
          <span class="font22 money-color"> {{ detail.totalPrice +(detail.bxPrice||0) }}</span>
          <span class="font10 gray"> {{ $t('E017','共') }}{{ detail.orderPsgBeanList.length }}人</span>
          &nbsp;
          <span
            class="font12 text-center"
            @click.stop="toggle('tabbar')"
          >
            <span>{{ $t('E006','明细') }}</span>
            <van-icon
              name="arrow-up"
              class="vertical-middle"
              size="14"
            />
          </span>
        </van-col>
        <!-- <van-col
          span="6"
          v-if="detail.isShowCancel"
        >
          <ld-button
            defaults
            size="md"
            @click="cancel(detail)"
          >
            取消
          </ld-button>
        </van-col> -->
        <van-col
          span="8"
          v-if="detail.isShowPay"
        >
          <ld-button
            main
            size="md"
            @click.stop="toPay(detail.id)"
          >
            立即支付
          </ld-button>
        </van-col>
        <van-col
          span="8"
          v-if="detail.isShowApproval"
        >
          <ld-button
            main
            size="md"
            @click="sendApproval(detail)"
          >
            立即送审
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>

    <!-- 支付 -->
    <!-- <ld-pay
      ref="pay"
      order-type="11001"
      :order-id="orderId"
    /> -->
  </div>
</template>

<script>
import ldHeader from 'Common/ldHeader'
import voyage from 'Components/tk/voyage'
import {Cell,Tag} from 'vant'
import ldButton from 'Common/ldButton'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import { mapGetters } from 'vuex'
import travelTips from 'Components/travelTips'
import traver from 'Components/tk/traver'
// import Bussiness from 'Utils/business'


export default {
  name:'TkCmp',
  components: {
    ldHeader,
    ldButton,
    voyage,
    traver,
    [Cell.name]:Cell,
    [Tag.name]:Tag,
    ldTabbar,
    travelTips
  },
  data(){
    return{
      flights:[],//订单集合
      priceList:[],
      airlineData:{}, // 航司入会
    }
  },
  computed:{
    ...mapGetters({
      tkSearchInfo: 'tk/tkSearchInfo',
    }),
    showFirstProductTypeColor () {
      return this.$route.query.showFirstProductTypeColor
    },
    // return{
    // 	'msg': 'string',
    // 	'orderList': [
    // 		{
    // 			'orderId': '43db5fe4cb6945cf8715c13e08f8a6a7',
    // 			'orderNo': 'string',
    // 			'pnrNo': 'string',
    // 			'pnrStatus': 'string'
    // 		}
    // 	],
    // 	'priceFlag': 'string'
    // }
    orderId(){
      return this.$route.query.orderId
    },
    priceFlag(){
      return this.$route.query.priceFlag
    },
    detail(){
      return this.flights[0]||{orderPsgBeanList:[]}
    },
    // priceList(){
    // 	return this.tkSearchInfo.priceList||[]
    // }
  },
  created(){
    this.init()
    console.log('待支付页面',this)
  },
  methods: {
    init(){
      if(this.priceFlag==1){
        this.$dialog.alert({ message: '当前预订舱位价格发生变化，系统已自动修改订单，实际价格以订单价格为准!'})
      }
      this.getDetail(this.orderId)
    },
    getDetail(orderId){
      this.$api['tkOrder/orderDetail']({
        id:orderId
      }).then(res => {
        let cache=res.data||{}
        this.airline = cache.airline
        this.getFindByAirline()
        this.flights.push(cache)
        var salePrice=0
        var airportFee=0
        var serviceFee=0
        var tax=0
        var aduNum=0
        var aduPrice=0
        var chdNum=0
        var chdPrice=0
        var infNum=0
        var infPrice=0
        var khjl=0
        if(cache.orderPsgBeanList){
          cache.orderPsgBeanList.forEach(item=>{
            if(item.psgType==1){
              salePrice=item.salePrice
              airportFee=item.airportFee
              serviceFee=item.serviceFee
              tax=item.tax
              khjl=item.khjl
              aduNum+=1
              aduPrice=item.salePrice+item.serviceFee+item.tax+item.airportFee
            }else if(item.psgType==2){
              chdNum+=1
              chdPrice=item.salePrice+item.serviceFee+item.tax+item.airportFee
            }else if(item.psgType==3){
              infNum+=1
              infPrice=item.salePrice+item.serviceFee+item.tax+item.airportFee
            }
          })
        }
        this.priceList = [{
          name: this.$t('C115','成人'),
          price: aduPrice,
          amount: aduNum,
          unit: this.$t('E113','人'),
          show:aduNum>0
        },{
          name: this.$t('C116','儿童'),
          price: chdPrice,
          amount: chdNum,
          unit: this.$t('E113','人') ,
          show:chdNum>0
        },{
          name: this.$t('C117','婴儿'),
          price: infPrice,
          amount: infNum,
          unit: this.$t('E113','人') ,
          show:infNum>0
        },{
          name: this.$t('A008','机票'), price: salePrice, amount: cache.orderPsgBeanList.length, unit: '/'+this.$t('E113','人') },
        { name: this.$t('E102','机建'), price: airportFee, amount: cache.orderPsgBeanList.length, unit: '/'+this.$t('E113','人') },
        { name: this.$t('E103','燃油税'), price: tax, amount: cache.orderPsgBeanList.length, unit: '/'+this.$t('E113','人') ,show:tax>0},
        { name: this.$t('E505','保险'), price: cache.bxPrice, amount: `/ ${cache.orderPsgBeanList.length*cache.orderRangeBeanList.length}份`, unit:'',show:cache.bxPrice>0},
        { name: this.$t('E001','服务费'), price: serviceFee, amount: cache.orderPsgBeanList.length, unit: '/'+this.$t('E113','人') },
        { name: '直减', price: '-'+khjl, amount: cache.orderPsgBeanList.length, unit: '/'+this.$t('E113','人') ,show:khjl>0}
        ]
      })
    },
    getFindByAirline(){
      this.$api['tkOrder/findByAirline']({
        airline:this.airline
      }).then(res => {
        this.airlineData = res.data || {}
      }).catch(res =>{
        this.$toast(res.errMsg)
      })
    },
    cancel(detail){
      // Bussiness.toOrderCancel({orderType: '11001',id:detail.id})
    },
    sendApproval(detail){//审批
      this.$router.push({path:'/approval/Send',query:{orderId:detail.id,orderNo:detail.orderNo,orderType:detail.orderType}})
    },
    toPay(orderId){//支付
      this.orderId=orderId
      // this.toggle('pay')
      this.$router.push({path:'/pay/payment',query:{orderType:'11001',orderId:this.orderId}})
    },
    toDetail(orderId) {//去详情
      this.$router.push({ path:'/tk/tkOrderDetail' , query:{ orderId: orderId} })
    },
    toggle(name){
      this.$refs[name].toggle()
    }
  },
  beforeDestroy(){
    this.$store.commit('tk/CLEAR_ALL',{})
  },
  filters:{
    getName(arr){
      let nameArr=arr.map(item=>{
        return item.psgName
      })
      return nameArr.join(',')
    }
  }
}
</script>

<style lang="less" scoped>
    .pad-8{
        padding: 8px;
    }
    .pad-b-5{
        padding-bottom: 5px;
    }
    .pad-b-20{
        padding-bottom: 20px;
    }
    .pad-lr-10{
        padding: 0 10px;
    }
    .qrCodbox{
      margin-top: 5px;
      padding: 10px;
      width: 100%;
      height: auto;
      background: white;
      text-align:center;
      margin-bottom: 50px;
      img{
        width: 130px;
        height: 130px;
        margin: 20px 0;
        background: black;
      }
      p{
        font-weight: 900;
        font-size: 18px;
      }
    }
</style>
